import request from './http'

//进入页面默认请求留言数据
export function fetchMessageBoard(data) {
    return request({
      url: `/marketall/msgBorad/getPageMsg`,
      method: 'post',
      data
    })
  }

//提交留言
export function submitMessage(data) {
  return request({
    url: `/marketall/msgBorad/submitMsg`,
    method: 'post',
    data
  })
}

//留言板后台 留言数量
export function msgBoradNum(data) {
  return request({
    url: `/marketall/msgBorad/getDailyMsgCount`,
    method: 'post',
    data
  })
}

//留言板后台 tabel表格数据
export function msgBoradTabel(data) {
  return request({
    url: `/marketall/msgBorad/getAllMsg`,
    method: 'post',
    data
  })
}
//回复留言
export function responMsg(data) {
  return request({
    url: `/marketall/msgBorad/responMsg`,
    method: 'post',
    data
  })
}

//个人中心 未读留言
export function getPrivateMsg(data) {
  return request({
    url: `/marketall/msgBorad/getPrivateMsg`,
    method: 'post',
    data
  })
}

//查询点赞 踩的数量
export function getPraise(data) {
  return request({
    url: `/marketall/msgBorad/getPageDetail`,
    method: 'post',
    data
  })
}

//点赞 踩
export function getClickPraisePoor(data) {
  return request({
    url: `/marketall/msgBorad/comment`,
    method: 'post',
    data
  })
}

